<template>
  <div>
    <b-container v-if="serveToolList.length > 0" class="bv-example-row">
      <b-row>
        <b-col cols="12">
          <b-table
            :items="serveToolList"
            :fields="tableToolConfig.fields"
            responsive="sm"
          >
            <template v-slot:cell(Actions)="row">
              <i
                size="sm"
                class="mr-2 fa fa-pencil"
                @click="handleStartEditTool(row.item)"
              >
              </i>
              <i
                size="sm"
                class="mr-2 fa fa-close"
                @click="handleClickRemoveBtn(row.item)"
              >
              </i>
            </template>
            <template v-slot:cell(Icon)="row" style="width: 100px">
              <tool-icon
                style="height: 60px; width: 60px"
                :name="row.item.text"
                :pp="row.item && row.item.uid && getImageTool(row.item.uid)"
              />
            </template>
          </b-table>
          <b-modal
            v-model="isModalUpdateTool"
            size="m"
            :hide-header="true"
            :hide-footer="true"
          >
            <b-form @submit.prevent="updateTool">
              <b-row>
                <b-col>
                  <!-- {{editedText}} -->
                  <b-row class="d-flex justify-content-center mb-3">
                    <tool-icon
                      style="height: 60px; width: 60px"
                      :name="editedText"
                      :pp="uid && getImageTool(uid)"
                    />
                  </b-row>
                  <b-row>
                    <b-input v-model="editedText" id="tool-name" name="text" />
                  </b-row>
                </b-col>
              </b-row>
              <div class="mt-4 d-flex">
                <b-button
                  class="mr-2"
                  size="sm"
                  variant="danger"
                  @click="
                    () => {
                      clearAllModalData();
                      isModalUpdateTool = false;
                    }
                  "
                >
                  Cancel
                </b-button>
                <b-button type="submit" size="sm" variant="success">
                  Save
                </b-button>
              </div>
            </b-form>
          </b-modal>
          <b-modal
            v-model="isModalRemoveTool"
            size="sm"
            :hide-header="true"
            :hide-footer="true"
          >
            <b-col>
              <b-row class="d-flex justify-content-center mb-3">
                <tool-icon
                  style="height: 60px; width: 60px"
                  :name="toolToRemove.text"
                  :pp="toolToRemove.uid && getImageTool(toolToRemove.uid)"
                />
              </b-row>
              <b-row>
                Are you sure you want to remove "{{ toolToRemove.text }}"?
              </b-row>
            </b-col>
            <div class="mt-4 d-flex">
              <b-button
                class="mr-2"
                size="sm"
                variant="danger"
                @click="
                  () => {
                    clearAllModalData();
                    isModalRemoveTool = false;
                  }
                "
              >
                Cancel
              </b-button>
              <b-button @click="handleRemoveTool" size="sm" variant="success">
                Yes
              </b-button>
            </div>
          </b-modal>
        </b-col>
      </b-row>
    </b-container>
    <template v-else>
      <b-card>
        <b-media no-body>
          <b-media-aside vertical-align="center">
            <b-img
              src="/trainempty.png"
              width="100%"
              height="100%"
              alt="No Focus"
            ></b-img>
          </b-media-aside>
          <b-media-body class="ml-3">
            <h2 class="mt-0">Don't you have &lt;T&gt;ools?</h2>
            <h4>
              You will soon - once you create our focused journey.
            </h4>
          </b-media-body>
        </b-media>
      </b-card>
    </template>
  </div>
</template>
<script>
// import SwitchFilter from "@/components/_savco/switch";
// import SavcoUserMenu from "@/components/_savco/layout/TopBar/UserMenu";
import toolIcon from "@/components/common/iconTool";

export default {
  components: {
    toolIcon,
    // SwitchFilter,
    // SavcoUserMenu
  },
  beforeCreate() {},
  methods: {
    getImageTool(uid) {
      if (
        this.$store.getters["user/listTools"].filter(el => el.uid === uid)[0] &&
        this.$store.getters["user/listTools"].filter(el => el.uid === uid)[0]
          .tooldetail
      ) {
        return this.$store.getters["user/listTools"].filter(
          el => el.uid === uid
        )[0].tooldetail.imgURL;
      } else {
        return null;
      }
    },
    handleEditNameClick() {
      this.isEditingName = !this.isEditingName;
    },
    createNewTool() {
      if (this.text) {
        this.$store
          .dispatch("user/addTool", {
            tool: {
              text: this.text
            }
          })
          .then(res => {
            if (res) {
              return this.$store.dispatch("user/getListTools").then(() => {
                console.log("successfully added new tool");
                this.clearAllModalData();
                this.isModalAddNewTool = false;
              });
            }
          })
          .catch(err => {
            console.log("error in adding new tool: ", err);
          });
      } else if (!this.text) {
        alert("Please fill the name of the tool");
      } else {
        alert("Please choose at least one sphere");
      }
    },
    handleStartEditTool(item) {
      this.editedText = item.text;
      this.uid = item.uid;
      this.editedTool = item;

      this.isModalUpdateTool = true;
    },
    handleClickRemoveBtn(item) {
      //debugger;
      this.toolToRemove = item;
      this.isModalRemoveTool = true;
    },
    checkedOrNot(sphere) {
      return this.editedFocuses.includes(sphere);
    },
    updateTool() {
      if (this.editedText) {
        this.$store
          .dispatch("user/updateTool", {
            tool: {
              ...this.editedTool,
              text: this.editedText,
              uid: this.uid
            }
          })
          .then(res => {
            // if(res) {
            // return this.$store.dispatch("user/getListTools")
            // .then(() => {
            console.log("successfully update the tool");
            this.clearAllModalData();
            this.isModalUpdateTool = false;
            // })
            // }
          })
          .catch(err => {
            console.log("error in adding new tool: ", err);
          });
      } else if (!this.editedText) {
        alert("Please fill the name of the tool");
      }
    },
    handleRemoveTool() {
      this.$store
        .dispatch("user/updateTool", {
          tool: {
            ...this.toolToRemove,
            _deleted_at: new Date()
          }
        })
        .then(res => {
          // return this.$store.dispatch("user/getListTools")
          // .then(() => {
          this.isModalRemoveTool = false;
          // this.toolToRemove = null;
          console.log("successfully delete a tool");
          // })
        })
        .catch(err => {
          console.log("error in deleting tool: ", err);
        });
    },
    clearAllModalData() {
      this.text = "";
      this.subText = "";
      this.notes = "";
      this.editedText = "";
      this.editedSubText = "";
      this.editedNotes = "";
    }
  },
  computed: {
    serveToolList() {
      let tableData = this.$store.getters["user/listTools"];
      let beforeFilterDeletedAt = tableData.map(el => {
        return {
          ...el,
          custom: el.text,
          tool: el.tooldetail ? el.tooldetail.name : "",
          description: el.tooldetail ? el.tooldetail.description : "",
          created: el._created_at
        };
      });
      return beforeFilterDeletedAt.filter(el => !el._deleted_at);
    }
  },
  data() {
    return {
      // FIELD FOR ADD JOURNEYS
      text: "",
      subText: "",
      notes: "",
      /////////////////////////
      //FIELD FOR UPDATE JOURNEYS
      editedText: "",
      editedSubText: "",
      editedFocuses: [],
      editedNotes: "",
      editedTool: null,
      uid: null,
      /////////////////////////
      //FIELD FOR REMOVE JOURNEY
      toolToRemove: {},
      /////////////////////////
      tableToolConfig: {
        fields: [
          { key: "Icon", sortable: false, label: "", thStyle: "width: 10%" },
          { key: "tool", sortable: true, label: "Name", thStyle: "width: 10%" },
          {
            key: "description",
            sortable: false,
            label: "Description",
            thStyle: "width: 30%"
          },
          /*{key: "created", sortable: false, label: "Added", thStyle:'width: 30%'},*/
          { key: "actions", label: "", sortable: false, thStyle: "width: 10%" }
        ]
        // sortBy: 'Tool',
        // sortDesc: false
      },
      isModalAddNewTool: false,
      isModalUpdateTool: false,
      isModalRemoveTool: false,
      spheres: [
        {
          sphere: "s",
          name: "(S)piritual"
        },
        {
          sphere: "h",
          name: "(H)ealth"
        },
        {
          sphere: "e",
          name: "(E)ducation"
        },
        {
          sphere: "f",
          name: "(F)inance"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("user/getListTools");
  }
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
<style scoped>
.button-add {
  width: 100%;
  background-color: #575757;
  color: white;
}
</style>
